import { setMiniCartUI, convertToNumber } from './cart';

export function init() {
  $(document).ready(() => {
    toastr.options = {
      "closeButton": true,
      "progressBar": true,
      "showDuration": "300",
      "hideDuration": "1000",
    }

    $('.addToCartBtn').click((e) => {
      e.preventDefault();

      const productId = parseInt($('.product-id').val());
      const productName = $('.product-name').text();
      const productImage = $('.product-image').attr('src');
      const productSize = $('input[name="product-size"]:checked').val();
      const productQuantity = parseInt($('#quantity').val());
      const productDiscount = parseInt($('.product-discount').text());
      const productPrice = convertToNumber($('input[name="product-size"]:checked').attr('oldPrice'));
      const productSlug = $('.product-name').attr('slug');

      const data = {
        id: productId,
        name: productName,
        image: productImage,
        size: productSize,
        quantity: productQuantity,
        discount: productDiscount,
        price: productPrice,
        slug: productSlug
      }
      const carts = JSON.parse(localStorage.getItem('carts'));

      if (carts.length !== 0) {
        let index = carts.findIndex(product => product.id === data.id && product.size === data.size);
        if (index === -1) {
          carts.push(data);
        } else {
          carts[index].quantity += data.quantity;
        }
        localStorage.setItem("carts", JSON.stringify(carts));
      } else {
        localStorage.setItem("carts", JSON.stringify([data]));
        $('.checkout-btn').show();
      }
      setMiniCartUI();
      toastr["success"]('Sản phẩm đã được thêm vào giỏ hàng.');
    })
  })
}
